var _white_path_list = [
  '/checkout',
  '/orders',
  '/preference',
  '/confirmation/[^/]+',
  '/my-account',
  '/crm',
];
export function isValidRedirectAfterLogin(pathName) {
  var matchedIndex = _white_path_list.findIndex((item) => {
    if (item === pathName || new RegExp('^' + item + '$').test(pathName)) {
      return true;
    }
  });
  if (matchedIndex === -1) {
    return false;
  }
  return true;
}
